import React from "react";

type Props = {
	title: string
	description: string
}

function SubpageHero({
	title,
	description,
}: Props) {
	return (
		<div className="bg-gray-900 w-100 pt-10 hero-scroll-background">
			<div className="container">
				<div style={ { lineHeight: 1.25 } } className="mb-4 text-4xl md:font-5xl lg:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-purple-600">
					{ title }
				</div>
				<div className="pb-20 text-white font-base md:text-lg font-light w-full lg:w-1/2">
					{ description }
				</div>
			</div>
		</div>
	);
}

export default SubpageHero;